// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionSteps_SaveAdditionalServiceStepsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/production_steps/save_additional_service_steps
 *
 * Replace all production steps for an additional service.
 */
import type { ProductionSteps_StepInputRow } from './ProductionSteps_StepInputRow'
import { registerContract } from './validate'

export interface ProductionSteps_SaveAdditionalServiceStepsInput {
additional_service_id: number
steps: ProductionSteps_StepInputRow[]
}

registerContract('ProductionSteps_SaveAdditionalServiceStepsInput', {
  additional_service_id: { type: 'number',  required: true },
  steps: {
    type: 'array',
    required: true,
    items: {
      production_step_id: { type: 'number',  required: true },
      is_terminal:        { type: 'number',  required: false },
    },
  },
})
